// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"697":"4cc45c8f9e01de58","979":"2a2cf29a9f5c2b57"}[chunkId] + ".js";
};